import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getPosSessionFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.pos_sessions.code.label',
      contentValue: `{{ ${entity}posSession.code }}`,
      description: 'templates.pos_sessions.code.description',
    },
    {
      label: 'templates.pos_sessions.status.label',
      contentValue: `{{ ${entity}posSession.status }}`,
      description: 'templates.pos_sessions.status.description',
    },
    {
      label: 'templates.pos_sessions.start_date.label',
      contentValue: `{{ ${entity}posSession.start_date | date("d/m/Y") }}`,
      description: 'templates.pos_sessions.start_date.description',
    },
    {
      label: 'templates.pos_sessions.start_time.label',
      contentValue: `{{ ${entity}posSession.start_time | date("H:i") }}`,
      description: 'templates.pos_sessions.start_time.description',
    },
    {
      label: 'templates.pos_sessions.end_date.label',
      contentValue: `{{ ${entity}posSession.end_date | date("d/m/Y") }}`,
      description: 'templates.pos_sessions.end_date.description',
    },
    {
      label: 'templates.pos_sessions.end_time.label',
      contentValue: `{{ ${entity}posSession.end_time | date("H:i") }}`,
      description: 'templates.pos_sessions.end_time.description',
    },
    {
      label: 'templates.pos_sessions.beginning_cash.label',
      contentValue: `{{ ${entity}posSession.beginning_cash }}`,
      description: 'templates.pos_sessions.beginning_cash.description',
    },
    {
      label: 'templates.pos_sessions.closing_cash_amount.label',
      contentValue: `{{ ${entity}posSession.closing_cash_amount }}`,
      description: 'templates.pos_sessions.closing_cash_amount.description',
    },
    {
      label: 'templates.pos_sessions.cash_error_amount.label',
      contentValue: `{{ ${entity}posSession.cash_error_amount }}`,
      description: 'templates.pos_sessions.cash_error_amount.description',
    },
    {
      label: 'templates.pos_sessions.cash_sales.label',
      contentValue: `{{ ${entity}posSession.cash_sales }}`,
      description: 'templates.pos_sessions.cash_sales.description',
    },
    {
      label: 'templates.pos_sessions.total_cash.label',
      contentValue: `{{ ${entity}posSession.total_cash }}`,
      description: 'templates.pos_sessions.total_cash.description',
    },
    {
      label: 'templates.pos_sessions.total_sales.label',
      contentValue: `{{ ${entity}posSession.total_sales }}`,
      description: 'templates.pos_sessions.total_sales.description',
    },
    {
      label: 'templates.pos_sessions.observations.label',
      contentValue: `{{ ${entity}posSession.observations }}`,
      description: 'templates.pos_sessions.observations.description',
    },
  ];
};

export const templatePosSession: EntityTemplateVariables = {
  fields: getPosSessionFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
